<template>
 <div class="contentWrap boxed ">
      <div class="d2-section">
        <div class="d2-section__header">
          <h2 class="d2-h2">
            <!-- <img class="mobiIcon" :src="HotPickIcon_gamebox" alt=""/> -->
             <span class="text_color">{{ $t("all") }} {{ $t("popular") }} {{ getSubCategory($route.query.q, lang_gamebox) }}</span>
          </h2>
        </div>
        <div v-if="isLoad === false">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>
         <div class="d2-section__content" v-if="isLoad === true">
            <div class="itemCollection row">
              <div  v-for="hot in getHotPicks()" :key="hot.key" :class="hot.class">
                <div v-if="$route.query.q === 'Video'">
                  <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(hot.content_id)">
                    <div class="d2-videoItem__thumb">
                      <img class="img_wrp" :src="hot.cover_img" alt="" />
                    </div>
                    <div class="playBtn"><span></span></div>
                    <div class="d2-videoItem__info">
                        <!-- <h3 class="mobiTitle sm">{{ hot.content_name }}</h3> -->
                        <span v-if="lang_gamebox !== 'english'">
                          <h3 class="d2-h4" v-if="hot[`cont_name_${lang_gamebox}`] !== ''">{{ hot[`cont_name_${lang_gamebox}`] }}</h3>
                          <h3 class="d2-h4" v-else>{{ hot[`cont_name_english`] }}</h3>
                        </span>
                        <span v-else>
                          <h3 class="d2-h4">{{ hot[`cont_name_english`] }}</h3>
                        </span>
                      <div>
                          <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                          <star-rating :inline="true" :star-size="14" :read-only="true" :increment="0.01" :show-rating="false" :border-width="2" border-color="#FFCF00" inactive-color="transparent" active-color="#FFCF00" :rounded-corners= "false" :star-points="[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17]"
                          :rating="Number(hot.rating)"></star-rating>
                      </div>
                    </div>
                  </a>
                </div>
                <div v-else>
                  <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(hot.content_id)">
                    <div class="d2-appItem__thumb">
                       <div v-if="hot.content_type === 'application/x-zip-compressed' && hot.parent_category === 'Game'" class="htmlBadge">
                      <img src="../../assets/gamebox/imgs/html5-badge.png"/>
                    </div>
                      <img class="img_wrp" :src="hot.thumbnail_url" alt="" />
                    </div>
                    <div class="d2-appItem__info">
                      <!-- <h3 class="mobiTitle sm text_color">{{hot.content_name}}</h3> -->
                      <span v-if="lang_gamebox !== 'english'">
                        <h4 class="d2-h4" v-if="hot[`cont_name_${lang_gamebox}`] !== ''">{{ hot[`cont_name_${lang_gamebox}`] }}</h4>
                        <h4 class="d2-h4" v-else>{{ hot[`cont_name_english`] }}</h4>
                      </span>
                      <span v-else>
                        <h4 class="d2-h4">{{ hot[`cont_name_english`] }}</h4>
                      </span>
                      <!-- <p>{{ hot.total_download }} {{$t("downloads")}}</p> -->
                      <star-rating :inline="true" :star-size="14" :read-only="true" :increment="0.01"  active-color="#FFCF00" :show-rating="false" :border-width="3" border-color="#FFCF00" :rounded-corners="false" inactive-color="transparent" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :rating="Number(hot.rating)"></star-rating>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
export default {
  data() {
    return {
      query: "",
      isLoad: false
    };
  },
  components:{
    StarRating
  },
  computed: mapGetters([
    "pageHotPicks_gamebox",
    "HotPickIcon_gamebox",
    "lang_gamebox",
    "country_gamebox"
  ]),
  props: ["browse"],
  created() {
    this.isLoad = false;
    this.fetchPageHotPicks_gamebox([this.$route.query.q]);
    this.getHotPicks();
  },
  updated() {
    if (this.$route.query.q != this.query) {
      this.isLoad = false;
      this.fetchPageHotPicks_gamebox([this.$route.query.q]);
      this.getHotPicks();
      this.query = this.$route.query.q;
    }
  },
  methods: {
    ...mapActions(["fetchPageHotPicks_gamebox"]),
    getDetail(id) {
      this.$root.$emit("getDetail", id);
    },
    getHotPicks() {
      let hotpick = [...this.pageHotPicks_gamebox];
      let hot = [];
      hotpick.map(item => {
        item["class"] =
          "col-6 col-md-2 col-lg-2 col-sm-4 d2-appItem d2-appItem--noAnim";
        hot.push(item);
      });
      setTimeout(() => {
        this.isLoad = true;
      }, 2500);
      return hot;
    },
    getSubCategory(subcategory, lang) {
      let cat_translate = [];
      let hotpick = this.$props.browse.category;

      hotpick.map(item => {
        if (item.title_english == subcategory) {
          if (lang != null) {
            cat_translate.push(item[`title_${lang}`]);
          } else {
            cat_translate.push(item[`title_english`]);
          }
        }
      });

      return cat_translate[0];
    }
  }
};
</script>

<style scoped>
.main_title {
  color: black;
}
.main_part div {
  display: inline-block;
  padding: 0 3px;
  color: black;
}
.browse_link {
  color: black;
}

.icon {
  height: 32px;
  width: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/HotPicks.vue